<template>
  <van-form>
    <van-field
      v-model="user.mobile"
      type="tel"
      label="手机号"
      @blur="blurphone"
    />
    <van-field
      v-model="user.code"
      center
      clearable
      maxlength="6"
      label="短信验证码"
      placeholder="请输入短信验证码"
      type="number"
    >
      <template #button>
        <van-button
          size="small"
          type="primary"
          :disabled="!countdown"
          v-bind:class="[countdown ? 'reg_active' : 'reg_disActive']"
          @click="getCode"
        >
          <span v-if="countdown">{{ text }}</span>
          <span v-if="!countdown">{{ text }} ({{ count }})</span>
        </van-button>
      </template>
    </van-field>
    <div style="margin: 16px">
      <van-button
        round
        block
        type="info"
        native-type="submit"
        @click="onLogin"
        style="background: #07c160"
      >
        登录
      </van-button>
    </div>
  </van-form>
</template>

<script>
import Vue from "vue";
import { Form, Toast } from "vant";
Vue.use(Form);
import { smsCode } from "@/api/apis";
import { isvalidPhone } from "@/utils/validate";
import { wxSocial } from "@/api/apis";
import { getToken } from "../../utils/auth";
export default {
  name: "login",
  data() {
    return {
      countdown: true,
      count: "",
      timer: null,
      text: "发送验证码",
      loading: false,
      user: {
        code: null,
        mobile: null,
        unionId: null,
      },
    };
  },
  mounted() {
    if (getToken()) {
      let redirect = sessionStorage.getItem("url");
      var url = window.location.href;
      url = url.split("?")[0] + "/#";
      this.$router.push({ path: redirect || "/newindex" });
    }
    // else {
    //   this.checkAuthor();
    // }
  },
  methods: {
    countDown() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.countdown = false;
        this.text = "重新发送";
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.countdown = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    getCode() {
      //验证手机号

      if (!isvalidPhone(this.user.mobile)) {
        Toast.fail("请输入正确手机号");
        return;
      }
      let params = {
        mobile: this.user.mobile,
      };
      var that = this;
      that.countDown();
      smsCode(params)
        .then((res) => {
          
        })
        .catch((error) => {
          Toast.fail("发送验证码失败，请稍后再试");
        });
    },
    onLogin(e) {
      var url = window.location.href;
      url = url.split("?")[0] + "/#";
      if (!isvalidPhone(this.user.mobile)) {
        Toast.fail("请输入正确手机号");
        return;
      }
      if (this.user.code.length !=6) {
        Toast.fail("请输入正确验证码");
        return;
      }

      this.loading = true;
      let that = this;
      let redirect = sessionStorage.getItem("url");
      this.$store
        .dispatch("Login", this.user)
        .then(() => {
          that.loading = false;
          let a = redirect || "/newindex";
          that.$router.push({ path: a });
        })
        .catch(() => {
          that.loading = false;
        });
    },
    blurphone() {
      if (this.user.mobile.length == 0) {
        Toast.fail("请输入手机号");
      }
    },
    checkAuthor() {
      
      let { registered, unionId, avatarPath, nickName } = this.$route.query;
      if (registered === null || registered === undefined) {
        
        this.author();
      } 
      // else if (registered == 'true') {
      //   this.loading = true;
      //   let that = this;
      //   console.log('微信登录')
      //   let redirect = sessionStorage.getItem("url");
      //   this.$store
      //     .dispatch("Login",{unionId,iswx:true})
      //     .then(() => {
      //       that.loading = false;
      //       let a = redirect || "/newindex";
      //       that.$router.push({ path: a });
      //     })
      //     .catch(() => {
      //       that.loading = false;
      //     });
      // } 
      else {
        this.user.unionId = unionId;
        this.user.avatarPath = avatarPath;
      }
    },
    author() {
      wxSocial()
        .then((res) => {
          
          console.log(res);
          // debugger
          window.location.href = res;
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
  },
};
</script>

<style scoped lang="less">
.reg_active {
  background: #07c160;
  color: #fff;
  border: none;
}
.reg_disActive {
  border: 1px solid @button-default-border-color;
  color: #323233;
  border: none;
}
</style>